/*
 *
 * LocalStorageProvider constants
 *
 */

export const REMOVE_SAVED_PLAN = 'app/LocalStorage/REMOVE_SAVED_PLAN';
export const UPDATE_SAVED_PLAN_NAME = 'app/LocalStorage/UPDATE_SAVED_PLAN_NAME';
export const ADD_SAVED_PLAN = 'app/LocalStorage/ADD_SAVED_PLAN';
export const SAVED_PLANS_LOCALSTORAGE_KEY = 'savedPlans';
export const LAST_VERSION_LOCALSTORAGE_KEY = 'lastVersion';
export const HAS_LOADED_OLD_PLAN_LOCALSTORAGE_KEY = 'hasLoadedOldPlan';
export const HAS_SEEN_NEW_FEATURES_LOCALSTORAGE_KEY = 'hasSeenNewFeatures';
export const CHECKED_SAVED_PLAN = 'app/LocalStorage/CHECKED_SAVED_PLAN';
export const SET_LAST_VERSION = 'app/LocalStorage/SET_LAST_VERSION';
export const SET_HAS_SEEN_NEW_FEATURES = 'app/LocalStorage/SET_HAS_SEEN_NEW_FEATURES';
export const SET_HAS_LOADED_OLD_PLAN = 'app/LocalStorage/SET_HAS_LOADED_OLD_PLAN';
export const CLOSE_PRODUCT_MESSAGE = 'app/LocalStorage/CLOSE_PRODUCT_MESSAGE';
